module.exports = __webpack_public_path__ + "img/ad.e15ddeab.svg";